import { render, staticRenderFns } from "./signature_report_real.vue?vue&type=template&id=3a385036&scoped=true"
import script from "./signature_report_real.vue?vue&type=script&lang=js"
export * from "./signature_report_real.vue?vue&type=script&lang=js"
import style0 from "./signature_report_real.vue?vue&type=style&index=0&id=3a385036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a385036",
  null
  
)

export default component.exports